import type { OperationManifest, ConnectorInfo } from '@/types/operationManifest';
import { OutputSecureDataMode, SettingScope } from '@/types/operationManifest';

// Core badge for operations requiring core infrastructure
const coreBadge = {
  name: 'core',
  description: 'Core functionality',
};

// Handoff icon SVG data
const handoffDataSvg =
  'data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjIiIGhlaWdodD0iMjIiIHZpZXdCb3g9IjAgMCAyMiAyMiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHJlY3Qgd2lkdGg9IjIyIiBoZWlnaHQ9IjIyIiByeD0iMiIgZmlsbD0iIzMzNTJCOSIvPgo8cGF0aCBkPSJNMTEgNkM4LjI0IDYgNiA4LjI0IDYgMTFDNiAxMy43NiA4LjI0IDE2IDExIDE2QzEzLjc2IDE2IDE2IDEzLjc2IDE2IDExQzE2IDguMjQgMTMuNzYgNiAxMSA2Wk0xMSAxNEMxMC4xNyAxNCAxMCAxMy44MyAxMCAxM0MxMCAxMi4xNyAxMC4xNyAxMiAxMSAxMkMxMS44MyAxMiAxMiAxMi4xNyAxMiAxM0MxMiAxMy44MyAxMS44MyAxNCAxMSAxNFpNMTIgMTBIMTBWN0gxMlYxMFoiIGZpbGw9IndoaXRlIi8+Cjwvc3ZnPg==';

export default {
  properties: {
    iconUri: handoffDataSvg,
    brandColor: '#3352b9',
    description: 'Handoff to another agent.',
    summary: 'Handoff',

    environmentBadge: coreBadge,

    inputs: {
      type: 'object',
      required: ['name'],
      properties: {
        name: {
          type: 'string',
          title: 'Agent Name',
          description: 'Agent Name',
          required: true,
          'x-ms-visibility': 'hideInUI',
          'x-ms-is-node-id': true,
        },
      },
    },
    isInputsOptional: false,

    outputs: {},
    isOutputsOptional: false,
    includeRootOutputs: true,

    connector: {
      id: '/connectionProviders/agent',
      name: 'Agent',
      properties: {
        description: 'Agent operations',
        displayName: 'Agent',
      },
    } as ConnectorInfo,

    settings: {
      secureData: {
        options: {
          outputsMode: OutputSecureDataMode.LinkedToInputs,
        },
      },
      trackedProperties: {
        scopes: [SettingScope.Action],
      },
    },
  },
} as OperationManifest;
